import { Pill } from "../ppm/ppmUtils";
import { TONE_CLASSES } from "../assets/assetUtils";
import { toast } from "sonner";
import { formatApiError } from "../../lib/api";

export { Pill, Spinner, fmtD } from "../ppm/ppmUtils";
export { Tile, fmtDT } from "../hs/hsUtils";

export const HR_ROLES = ["super_admin", "hr_manager"];
/** Who gets the HR hub: super admins, HR managers, and admins / PMs flagged as operations director (the API enforces the same rule). */
export const isHr = (user) => !!user && (HR_ROLES.includes(user.role) || (["admin", "project_manager"].includes(user.role) && !!user.operations_director));

export const err = (e, fallback) => toast.error(e?.response?.data?.detail ? formatApiError(e.response.data.detail) : fallback);

const TONE = { overdue: TONE_CLASSES.overdue, soon: TONE_CLASSES.soon, ok: TONE_CLASSES.ok, none: TONE_CLASSES.none };
export const STATUS_TONE = { active: TONE_CLASSES.ok, onboarding: TONE_CLASSES.soon, leaver: TONE_CLASSES.none };
export const RTW_TONE = { verified: TONE_CLASSES.ok, expiring: TONE_CLASSES.soon, expired: TONE_CLASSES.overdue, not_checked: TONE_CLASSES.overdue, not_required: TONE_CLASSES.none };
export const EXPIRY_TONE = { expired: TONE_CLASSES.overdue, expiring: TONE_CLASSES.soon, ok: TONE_CLASSES.ok, "": TONE_CLASSES.none };

export const FlagPill = ({ flag }) => <Pill tone={TONE[flag.tone] || TONE_CLASSES.none} testid={`hr-flag-${flag.key}`}>{flag.label}</Pill>;

export const initials = (name = "") => name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("");

export function Avatar({ name, size = "md" }) {
  const cls = size === "lg" ? "h-14 w-14 text-lg" : size === "sm" ? "h-7 w-7 text-[10px]" : "h-9 w-9 text-xs";
  return <div className={`${cls} shrink-0 rounded-full bg-primary/15 text-primary font-bold flex items-center justify-center`} aria-hidden>{initials(name) || "?"}</div>;
}

export const addressLine = (a) => (a ? [a.line1, a.line2, a.town, a.county, a.postcode].filter(Boolean).join(", ") : "");

export const fmtBytes = (n) => (!n && n !== 0 ? "" : n < 1024 ? `${n} B` : n < 1048576 ? `${(n / 1024).toFixed(0)} KB` : `${(n / 1048576).toFixed(1)} MB`);

/** Section card used throughout the employee record. */
export function Section({ title, icon: Icon, action, children, testid }) {
  return (
    <section className="rounded-lg border border-border bg-card" data-testid={testid}>
      <header className="flex items-center justify-between gap-2 px-4 py-2.5 border-b border-border">
        <h3 className="text-sm font-semibold flex items-center gap-2">{Icon && <Icon size={15} className="text-primary" />}{title}</h3>
        {action}
      </header>
      <div className="p-4">{children}</div>
    </section>
  );
}

export const Field = ({ label, value, testid }) => (
  <div data-testid={testid}>
    <p className="text-[11px] uppercase tracking-wide text-muted-foreground">{label}</p>
    <p className="text-sm break-words">{value || <span className="text-muted-foreground">—</span>}</p>
  </div>
);
